import { formatBytes } from '@fourthwall/utils/dist/file';
export const formatSubscriptionBytes = (bytes) => formatBytes(bytes, {
    unit: 'decimal',
    decimals: 2,
    rounding: false,
});
